import { Box, Typography, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import ConstructionIcon from "@mui/icons-material/Construction";

export default function AsanaConfig() {
  const { t } = useTranslation(["bugherd"]);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        mb: 2.5,
        borderRadius: "10px",
        border: (theme) => `1px solid ${theme.palette.divider}`,
        bgcolor: (theme) => theme.palette.background.paper,
      }}
    >
      <Typography
        variant="subtitle2"
        fontWeight={600}
        fontSize="13px"
        mb={2}
        color="text.secondary"
      >
        {t("Asana Integration")}
      </Typography>

      <Box
        sx={{
          p: 4,
          textAlign: "center",
          borderRadius: "8px",
          bgcolor: (theme) =>
            theme.palette.mode === "dark"
              ? "rgba(255, 255, 255, 0.03)"
              : "#f9f9f9",
          border: (theme) => `1px dashed ${theme.palette.divider}`,
        }}
      >
        <ConstructionIcon
          sx={{ fontSize: 40, color: "text.secondary", mb: 1 }}
        />
        <Typography variant="body2" color="text.secondary" fontSize="13px">
          {t("Asana integration is coming soon.")}
        </Typography>
      </Box>
    </Paper>
  );
}
